'use strict';
import * as $i_js$002dcookie from "js-cookie";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_cookies$Cookies$() {
}
export { $c_Lpresto_cookies$Cookies$ as $c_Lpresto_cookies$Cookies$ };
$p = $c_Lpresto_cookies$Cookies$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_cookies$Cookies$;
/** @constructor */
function $h_Lpresto_cookies$Cookies$() {
}
export { $h_Lpresto_cookies$Cookies$ as $h_Lpresto_cookies$Cookies$ };
$h_Lpresto_cookies$Cookies$.prototype = $p;
$p.adk = (function(name) {
  var x1 = $i_js$002dcookie.default.get(name);
  if (((typeof x1) === "string")) {
    return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some(x1);
  }
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.cNF = (function(name) {
  $i_js$002dcookie.default.remove(name);
});
var $d_Lpresto_cookies$Cookies$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_cookies$Cookies$, "presto.cookies$Cookies$", ({
  Vf: 1
}));
export { $d_Lpresto_cookies$Cookies$ as $d_Lpresto_cookies$Cookies$ };
var $n_Lpresto_cookies$Cookies$;
function $m_Lpresto_cookies$Cookies$() {
  if ((!$n_Lpresto_cookies$Cookies$)) {
    $n_Lpresto_cookies$Cookies$ = new $c_Lpresto_cookies$Cookies$();
  }
  return $n_Lpresto_cookies$Cookies$;
}
export { $m_Lpresto_cookies$Cookies$ as $m_Lpresto_cookies$Cookies$ };
//# sourceMappingURL=presto.cookies$-Cookies$.js.map
